import { useQuery } from '@apollo/client';
import { StaffFinanceBatchContainerGlPostingSummariesByDateRangeDocument, StaffFinanceBatchContainerGlPostingSummaryFieldsFragment } from '../../../../generated';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { FinanceBatch } from './finance-batch';
import { useState } from 'react';

interface FinanceBatchContainerProps {}

export const FinanceBatchContainer: React.FC<FinanceBatchContainerProps> = () => {
  const [filterDates, setFilterDates] = useState<{ startDate: string | null; endDate: string | null } | null>({ startDate: null, endDate: null });

  const {
    data: financeBatchData,
    loading: financeBatchLoading,
    error: financeBatchError
  } = useQuery(StaffFinanceBatchContainerGlPostingSummariesByDateRangeDocument, {
    variables: {
      startDate: filterDates?.startDate ?? null,
      endDate: filterDates?.endDate ?? null
    }
  });

  return (
    <ComponentQueryLoader
      loading={financeBatchLoading}
      error={financeBatchError}
      hasData={!!financeBatchData}
      hasDataComponent={
        <FinanceBatch
          data={financeBatchData?.glPostingSummariesByDateRange as StaffFinanceBatchContainerGlPostingSummaryFieldsFragment[]}
          setFilterDates={setFilterDates}
          filterDates={filterDates}
        />
      }
    />
  );
};

